<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ii"></a><a id="ch00_fm02"></a><strong>RACE, RELIGION, AND ETHNICITY<br/>General Editor: Peter J. Paris</strong></p>
<p class="center1"><em>Public Religion and Urban Transformation:<br/>Faith in the City</em><br/>Edited by Lowell W. Livezey</p>
<p class="center1"><em>Down by the Riverside:<br/>Readings in African American Religion</em><br/>Edited by Larry G. Murphy</p>
<p class="center1"><em>New York Glory:<br/>Religions in the City</em><br/>Edited by Tony Carnes and Anna Karpathakis</p>
<p class="center1"><em>Religion and the Creation of Race and Ethnicity<br/>An Introduction</em><br/>Edited by Craig R. Prentiss</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?4e857046